import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import Link from '../utils/link'

const NextProject = ({ uri, acf, title }) => {

  return (
    <section className="latest-media">
      <Link to={uri} className="latest-media__inner">
        <GatsbyImage image={getImage(acf.gallery[0]?.localFile)} alt={title} />
        <h2 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{ acf.tag }</p>
      </Link>
    </section>
  );
}

export default NextProject